import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(
  () => ({
    layout: {
      // border: '2px solid red',
      width: '54%',
      display: 'flex',
      flexDirection: 'column',
    },
    pdftab: {
      //   height: '10%',
      //   border: '2px solid green',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'no-wrap',
      marginBottom: '10px',
      justifyContent: 'flex-start',
      // overflow: true,
      //   alignItems: 'center',
    },
    pdf: {
      height: '100%',
      width: '100%',
      // border: '2px solid red',
    },
    download: {
      height: '10%',
      // border: '2px solid black'
    },
  }),
  { index: 1 },
)

export { useStyles }
